import { hyphenateSync as hyphen } from "hyphen/nl";
import { getConfig } from "./featureSwitch";
const hyphenationConfigs = {
    vbp: {
        auto: 'on',
        manual: 'on'
    },
    aanzet: {
        auto: 'on',
        manual: 'on'
    },
    bkw: {
        auto: 'off',
        manual: 'off'
    },
    dnb: {
        auto: 'off',
        manual: 'off'
    },
    flevo: {
        auto: 'off',
        manual: 'off'
    },
    rdam: {
        auto: 'on',
        manual: 'on'
    },
    twente: {
        auto: 'off',
        manual: 'on'
    }
};
const hyphenationConfig = getConfig(hyphenationConfigs);
export const hyphenate = (text)=>{
    // Return the original text if it's not a string or is empty
    if (!text || typeof text !== 'string') return text;
    const { auto, manual } = hyphenationConfig();
    // If manual hyphenation is enabled and relevant for this text
    if (manual == 'on' && text.includes('|')) {
        let result = text;
        // If pipe is found around space, replace all others with non-breaking-space.
        // This allows editors to force a break after a particular word, but only when the text does not fit on one line.
        if (text.includes(' |') || text.includes('| ')) {
            result = text.replace(/ /g, '\u00A0').replace(/(\u00A0\|)|(\|\u00A0)/g, ' ');
        }
        return result.replace(/(-\|)|(\|-)/g, '-') // If the pipe (`|`) is placed near an actual hyphen, we prefer to use that hyphen over the proposed soft-hyphen.
        .replace(/\|/g, '\u00AD') // Otherwise replace the pipe with a soft-hyphen.
        ;
    }
    return auto == 'on' ? hyphen(text) : text;
};
